<div class="rendered-section" [ngClass]="'level-' + headingLevel">
  <h3 class="section-heading" *ngIf="node.name && !hideHeading">{{ node.name }}</h3>

  <div class="fields-grid" *ngIf="node.fields?.length">
    <app-field-renderer
      *ngFor="let field of node.fields"
      [field]="field"
      [readonly]="readonly"
      [showValidation]="showValidation"
    ></app-field-renderer>
  </div>

  <div class="subsection-list" *ngIf="node.subSections?.length">
    <app-section-renderer
      *ngFor="let sub of node.subSections"
      [node]="sub"
      [readonly]="readonly"
      [showValidation]="showValidation"
      [headingLevel]="3"
    ></app-section-renderer>
  </div>
</div>
